export default __webpack_public_path__ + "static/media/consent_form.21c1ef59.pdf";